<!-- eslint-disable eqeqeq -->
<template>
  <crec-modal class="goLoginDialog" title="" :footer="null" :visible.sync="computedShow" width="400px" append-to-body @ok="handleClose('ok')" @cancel="handleClose('close')">
      <crec-form-model ref="loginForm" :model="loginForm" :rules="loginRules" :class="['webLoginForm', activeName == '2' ? 'smallFormLabel' : '']">
        <crec-tabs @tab-click="handleClick" v-model="activeName">
          <crec-tab-pane tab="验证码登录" key="2" />
          <crec-tab-pane tab="账号密码登录" key="1" />
        </crec-tabs>
        <crec-form-model-item prop="username" label="账号">
          <crec-input v-model="loginForm.username" type="text" auto-complete="off" placeholder="请输入手机号码"></crec-input>
        </crec-form-model-item>
        <crec-form-model-item prop="password" label="密码" v-if="activeName == '1'" class="passwordEye">
          <crec-input-password v-model="loginForm.password" :type="isPassword?'text':'password'" auto-complete="off" placeholder="请输入密码" @keyup.enter.native="handleLogin">
            <!-- <svg-icon slot="suffix" :icon-class="isPassword?'eye-open':'eye'" class="svgEye" @click="isPassword=!isPassword" /> -->
          </crec-input-password>
        </crec-form-model-item>
        <crec-form-model-item prop="code" label="验证码" v-if="activeName == '2'" class="codePhone">
          <crec-input v-model="loginForm.code" type="number" auto-complete="off" placeholder="请输入短信验证码" style="width: 63%" @keyup.enter.native="handleLogin" />
          <crec-button class="send-code" @click="sendCode">{{sendMsg}}</crec-button>
        </crec-form-model-item>
        <crec-form-model-item class="loginBox">
          <crec-button
            :loading="loading"
            type="primary"
            @click.native.prevent="handleLogin"
          >
            <span v-if="!loading">登 录</span>
            <span v-else>登 录 中...</span>
          </crec-button>
        </crec-form-model-item>
        <div class="register">
          <a class="link-type" @click="handleClose(register)">
            没有账号，立即注册
          </a>
        </div>
      </crec-form-model>
    <!-- 密码修改 -->
    <crec-modal
      :visible.sync="open"
      :mask-closable="false"
      :close-on-click-modal="false"
      width="500px"
      append-to-body
    >
      <div slot="title" class="el-dialog__title">
        密码修改<span class="text-danger ml0 fs12 fw600"
      >您的密码安全性需要加强，请修改</span
      >
      </div>
      <crec-form-model ref="form" :model="user" :rules="rules" label-width="86px">
        <crec-form-model-item label="旧密码" prop="oldPassword">
          <crec-input
            v-model="user.oldPassword"
            placeholder="请输入旧密码"
            type="password"
          />
        </crec-form-model-item>
        <crec-form-model-item label="新密码" prop="newPassword">
          <crec-input
            v-model="user.newPassword"
            placeholder="请输入新密码"
            type="password"
          />
        </crec-form-model-item>
        <crec-form-model-item label="确认密码" prop="confirmPassword">
          <crec-input
            v-model="user.confirmPassword"
            placeholder="请确认密码"
            type="password"
          />
        </crec-form-model-item>
      </crec-form-model>
      <div slot="footer" class="dialog-footer">
        <crec-button type="primary" @click="submitPasswordForm"
        >确 定</crec-button
        >
      </div>
    </crec-modal>
  </crec-modal>
</template>

<script>
import { getCodeImg,  getSmsCode} from "@/api/login";
import Cookies from "js-cookie";
import { encrypt, decrypt } from "@/utils/jsencrypt";
import { RegexUtil } from "@/utils/base/RegexUtil";
import { updateWebUserPwd } from "@/api/system/user";
export default {
  name:'LoginLogin',
  props:{
    show:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      // show: false,
      // 二维码PK
      pkQrCode:'',
      // 二维码所属单位
      pkCompany:'',
      companyName:'',
      codeUrl: "",
      loginForm: {
        username: "",
        password: "",
        rememberMe: false,
        code: "",
        uuid: "",
      },
      loginRules: {
        username: [
          { required: true, trigger: "blur", message: "请输入您的账号" },
        ],
        password: [
          { required: true, trigger: "blur", message: "请输入您的密码" },
        ],
        code: [{ required: true, trigger: "change", message: "请输入验证码" }],
      },
      loading: false,
      // 验证码开关
      captchaOnOff: true,
      // 注册开关
      register: true,
      redirect: undefined,
      // 是否显示弹出层
      open: false,
      // 密码修改数据对象
      user: {
        oldPassword: undefined,
        newPassword: undefined,
        confirmPassword: undefined,
      },
      // 重置密码表单校验
      rules: {
        oldPassword: [
          { required: true, message: "旧密码不能为空", trigger: "blur" },
        ],
        newPassword: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!RegexUtil.isValidPassword(value)) {
                callback(
                  new Error(
                    "必须包含大小写字母、数字、特殊字符， 8 到 30 个字符"
                  )
                );
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        confirmPassword: [
          { required: true, message: "确认密码不能为空", trigger: "blur" },
          {
            required: true,
            validator: (rule, value, callback) => {
              if (this.user.newPassword !== value) {
                callback(new Error("两次输入的密码不一致"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },

      activeName: "2",
      sendMsg: "发送验证码",
      isPassword: false,

      openType: '',

    };
  },
  computed: {
    computedShow: {
      get() {
        return this.show
      }
    }
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true,
    },
  },
  created() {
    this.loginForm.username = localStorage.getItem("userName");
    let bundle = this.$route.query;
    // 二维码PK
    this.pkQrCode = bundle.pkQrCode;
    // 二维码所属单位
    this.pkCompany = bundle.pkCompany;
    this.companyName = bundle.companyName;
    this.captchaOnOff = false;
    this.getCookie();
  },
  methods: {
    getCode() {
      if(!this.captchaOnOff){
        return false;
      }
      getCodeImg().then((res) => {
        this.captchaOnOff =
          res.captchaOnOff === undefined ? true : res.captchaOnOff;
        if (this.captchaOnOff) {
          this.codeUrl = "data:image/gif;base64," + res.img;
          this.loginForm.uuid = res.uuid;
        }
      });
    },
    getCookie() {
      const username = Cookies.get("username");
      const password = Cookies.get("password");
      const rememberMe = Cookies.get("rememberMe");
      this.loginForm = {
        username: username === undefined ? this.loginForm.username : username,
        password:
          password === undefined ? this.loginForm.password : decrypt(password),
        rememberMe: rememberMe === undefined ? false : Boolean(rememberMe),
      };
    },
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          console.log('提交的表单数据：', this.loginForm)
          this.loading = true;
          if (this.loginForm.rememberMe) {
            Cookies.set("username", this.loginForm.username, { expires: 30 });
            Cookies.set("password", encrypt(this.loginForm.password), {
              expires: 30,
            });
            Cookies.set("rememberMe", this.loginForm.rememberMe, {
              expires: 30,
            });
          } else {
            Cookies.remove("username");
            Cookies.remove("password");
            Cookies.remove("rememberMe");
          }
          if(this.activeName == '1'){
            this.$store.dispatch("WebLogin", this.loginForm)
              .then(() => {
                this.handleClose();
                this.setOpenType();
              })
              .catch(() => {
                this.loading = false;
              });
          } else {
            this.$store
              .dispatch("WebLoginCode", this.loginForm)
              .then(() => {
                this.handleClose();
                this.setOpenType();
              })
              .catch(() => {
                this.loading = false;
              });
          }
        }
      })
    },
    submitPasswordForm() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          updateWebUserPwd(this.user.oldPassword, this.user.newPassword).then(
            () => {
              this.$modal.msgSuccess("修改成功");
              this.$store.dispatch("LogOut").then(() => {
                setTimeout(function () {
                  window.location.reload();
                }, 500);
              });
            }
          );
        }
      });
    },
    handleClick(){
      this.$refs.loginForm.resetFields()
    },
    sendCode(){
      if (!this.loginForm.username) {
        return this.$message.warning('请先输入手机号');
      }
      this.isSend = false;
      let timer = 60;
      this.sendMsg = timer + "s";
      this.timeFun = setInterval(() => {
        --timer;
        this.sendMsg = timer + "s";
        if (timer == 0) {
          this.isSend = true;
          this.sendMsg = "重新发送";
          clearInterval(this.timeFun);
        }
      }, 1000);
      getSmsCode(this.loginForm.username)
    },
    handleClose(val) {
      if (val === 'ok') {
        this.handleLogin()
        return
      }
      this.loading = false;
      this.loginForm.password = '';
      if(val){
        this.$emit('closeValue',val)
      } else {
        localStorage.setItem('loginUser',this.loginForm.username);
        this.$emit('closeValue')
      }
    },
    setOpenType(){
      if(RegexUtil.isEmpty(this.pkQrCode) || RegexUtil.isEmpty(this.pkCompany)){
        this.openType = 'web'
      } else {
        this.openType = 'qrCode'
      }
      localStorage.setItem("openType", this.openType);
    }
  },
};
</script>

<style lang="less">
.goLoginDialog{
  .crec-modal-content{
    width: 400px;
    border-radius: 14px;
    .webLoginForm{
      padding: 0 0 20px;
      //height: 450px ;
      .crec-tabs-bar{
        text-align: center;
        margin-bottom: 40px;
      }
      &.smallFormLabel {
        .crec-form-item-label {
          width: 80px;
        }
        .crec-form-item-control-wrapper {
          margin-left: 80px;
        }
      }
      .codePhone {
        .crec-form-item-children {
          display: flex;
        }
        .send-code {
          margin-left: 10px;
          font-size: 12px;
        }
      }
      .crec-form-item-label {
        float: left;
        width: 80px;
        font-weight: bold;
      }
      .crec-form-item-control-wrapper {
        margin-left: 80px;
      }
      .loginBox{
        text-align: center;
        margin: 60px 0 0 0;
        .crec-form-item-control-wrapper {
          margin-left: 0 !important;
        }
        .crec-form-item-children {
          display: inline-block;
          width: 80%;
        }
        .crec-btn{
          width: 100%;
          padding: 10px 20px;
          font-size: 14px;
          border-radius: 4px;
          line-height: 1;
        }
      }
      .register,.login1{
        text-align: right;
        & a{color: #1961ac;font-size: 12px}
      }
      .register{margin-top: 60px;}
      .login1{margin-top: 60px;}
      .passwordEye{
        position: relative;
        .svgEye{
          position: absolute;
          right: 15px;
          top: 10px;
          cursor: pointer;
          color: #666666;
        }
      }
    }
  }
}
</style>
